<template>
    <div>
        <el-form-item :label="field.name + '：'" label-width="110px">
            <el-select clearable  v-model="config[field.key]" @change="change" :placeholder="field.memo">
                <el-option
                        v-for="item in field['option-list']"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                </el-option>
            </el-select>
        </el-form-item>
    </div>
</template>

<style lang="scss" scoped>

</style>

<script>

  /**
   * Created by huangdonglin on 2018/1/3.
   */
  export default {
    name: 'tms-type-select',
    props: {
      field: {
        type: [Object, Array],
        required: true
      },
      source: {
        type: String,
      }
      // config: {
      //   type: Object,
      //   default() {
      //     return {}
      //   }
      // }
    },
    computed: {
      // 基础组件的 数据初始化 判断是常规组件渲染 还是基础组件渲染
      config() {
        if (this.source === 'tmsPageConfig') {
          return this.$store.state.tms.pageData
        }
        if (this.source === 'tmsModuleConfig') {
          return this.$store.state.tms.config;
        }
        return this.$store.state.tms.customConfig;
      }
    },
    data() {
      return {
        page_link_type: ''
      }
    },

    components: {},

    mounted() {
      if (!this.config[this.field.key]) {
        this.config[this.field.key] = 0;
      }

    },

    methods: {
      change(val) {
        this.config[this.field.key] = val;
      }
    }
  }

</script>
